// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"c00ada9f","146":"fd5b22f9","190":"673d8f08"}[chunkId] + ".chunk.css";
};